import { create } from 'zustand';
import { templateRegistry } from '../../templates';
import type { TemplateProfile, GraphLayoutType, LayoutConfig } from '../../templates/types';
import { logger } from '../../core/logging';
import { AppError, AppErrorCode } from '../../core/errors/AppError';

type TemplateStore = {
  activeTemplateId: string;
  activeProfile: TemplateProfile;
  setActiveTemplate: (id: string) => void;
};

const initialProfile = templateRegistry.get('base');

export const useTemplateStore = create<TemplateStore>((set) => ({
  activeTemplateId: 'base',
  activeProfile: initialProfile,
  setActiveTemplate(id: string) {
    try {
      const p = templateRegistry.get(id);
      set({ activeTemplateId: id, activeProfile: p });
    } catch (err) {
      logger.error('Failed to set active template', { id, err });
    }
  },
}));

export function getActiveProfile(state: TemplateStore): TemplateProfile {
  return state.activeProfile;
}

export function getActiveLayoutConfig(state: TemplateStore, layoutType: GraphLayoutType): LayoutConfig {
  const profile = state.activeProfile;
  if (!profile.supportedLayoutTypes.includes(layoutType)) {
    throw new AppError(`Layout not supported: ${layoutType}`, AppErrorCode.INVALID_LAYOUT_CONFIG, { profile: profile.id });
  }
  return profile.layouts[layoutType];
}
